import React from "react"
import PropTypes from "prop-types"

export default function TextInput({
  value,
  onChange,
  name,
  placeholder,
  type,
  readOnly,
  className = "",
  pattern,
}) {
  return (
    <input
      type={type}
      className={`form-control ${className}`}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      disabled={readOnly}
      pattern={pattern}
    />
  )
}

TextInput.defaultProps = {
  value: "",
  onChange: null,
  placeholder: "",
  type: "text",
  readOnly: false,
}

TextInput.propTypes = {
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
}
